import React from "react";
import Link from "next/link";
import Image from "next/image";
import classNames from "classnames";
import { apiUrl, getbookingUrl } from "@/utils/api";

const RoomsCard = ({ t, className = "", room, columns = 6, from = "", priceNight = {} }) => {
  const room_sliders = room.id
    ? room.locale === "es"
      ? room.room_sliders
      : room.localizations[0].room_sliders
    : [];
  const thumbnail =
    (room_sliders?.length && room_sliders[0].image
      ? {
          ...room_sliders[0].image,
          url: apiUrl + room_sliders[0].image.url,
        }
      : false) ||
    room.image ||
    false;

  const gtmBookId = room?.locale === "es" && `room-${room?.slug}` || room?.locale === "en" && `room-${room?.localizations[0]?.slug}` || ""
  const gtmMoreId = room?.locale === "es" && `more-${room?.slug}` || room?.locale === "en" && `more-${room?.localizations[0]?.slug}` || ""

  return (
    <div className={classNames(className, "rounded-lg ")}>
      <div
        className={classNames(
          "room-card-content h-64 w-auto sm:h-96 md:h-auto",
          { "lg:h-[355px]": columns === 6 },
          { "lg:h-[470px]": columns === 4 }
        )}
      >
        {thumbnail && (
          <Image
            width={thumbnail.width}
            height={thumbnail.height}
            src={thumbnail.url}
            alt="room"
            className="h-full w-full object-cover"
          />
        )}
        <div className="room-card-info  px-4 py-4 md:px-8 lg:px-8 md:py-8 lg:py-8">
          <div className="room-card-info-container base-grid gap-y-1 w-full">
          <div className="col-span-6 ">
              <h3 className="font-title text-white text-lg md:text-2xl lg:text-2xl leading-6">
                {room.name}
              </h3>
              <span className="font-title text-white text-xs md:text-sm lg:text-sm uppercase">
                {room.view || room.room_category.name}
              </span>
            </div>
            <div className="col-span-3 col-start-10 ">    
              <span className="font-title text-white text-[9px] lg:text-[12px] uppercase ml-[25px] lg:ml-[35px]">
                {from || ""}:
              </span>
              <h3 className="first-letter:text-[13px] lg:first-letter:text-[20px] font-title text-white text-[18px] lg:text-[28px] leading-6">
                ${room.price}
              </h3>
              <span className="font-title text-white text-[9px] lg:text-[12px] uppercase">
                {priceNight.currency + " / " + priceNight.night}
              </span>
            </div>
            {/* <div className="col-span-4 flex flex-col items-end">
              <span className="font-subtitle text-white text-xxs md:text-xs lg:text-xs tracking-widest uppercase">
                {t("rooms:rooms_details.from")}
              </span>
              <h4 className="font-title text-white text-lg md:text-2xl lg:text-2xl">
                <span className="text-sm md:text-xl lg:text-xl">$</span>
                {room.price}
              </h4>
              <span className="font-subtitle text-white text-xxs md:text-xs lg:text-xs tracking-widest uppercase">
                {t("rooms:rooms_details.currency")}/
                {t("rooms:rooms_details.night")}
              </span>
            </div> */}
            <div className="col-span-12 amenities-container ">
              <div className="base-grid gap-2 lg:gap-4">
                {room.capacity && (
                  <div className="col-span-6 lg:col-start-2 lg:col-span-8 flex justify-start items-center gap-7">
                    <Image
                      width={20}
                      height={20}
                      src="/images/icons/amenity-people.svg"
                      alt="icon"
                      className="w-3.5 md:w-5 lg:w-5"
                    />
                    <span className="font-subtitle text-white text-xxs md:text-sm lg:text-sm uppercase">
                      {room.capacity}
                    </span>
                  </div>
                )}
                {room.beds && (
                  <div className="col-span-6 lg:col-start-2 lg:col-span-8 flex justify-start items-center gap-7">
                    <Image
                      width={20}
                      height={20}
                      src="/images/icons/amenity-bed.svg"
                      alt="icon"
                      className="w-3.5 md:w-5 lg:w-5"
                    />
                    <span className="font-subtitle text-white text-xxs md:text-sm lg:text-sm uppercase">
                      {room.beds}
                    </span>
                  </div>
                )}
                {room.area && (
                  <div className="col-span-6 lg:col-start-2 lg:col-span-8 flex justify-start items-center gap-7">
                    <Image
                      width={20}
                      height={20}
                      src="/images/icons/amenity-area.svg"
                      alt="icon"
                      className="w-3.5 md:w-5 lg:w-5"
                    />
                    <span className="font-subtitle text-white text-xxs md:text-sm lg:text-sm uppercase">
                      {room.area}
                    </span>
                  </div>
                )}

                {/* {Array.isArray(room.amenities) &&
                  room.amenities.map((amenity, key) => {
                    return (
                      <div
                        key={key}
                        className="col-span-6 lg:col-start-2 lg:col-span-8 flex justify-start items-center gap-7"
                      >
                        <Image
                          width={20}
                          height={20}
                          src="/images/icons/amenity-people.svg"
                          alt="icon"
                          className="w-3.5 md:w-5 lg:w-5"
                        />
                        <span className="font-subtitle text-white text-xxs md:text-sm lg:text-sm uppercase">
                          {amenity.description}
                        </span>
                      </div>
                    );
                  })} */}
              </div>
            </div>
            <div className="col-span-12 flex items-center gap-10 room-card-button-container lg:hover:grid lg:hover:gap-2">
              <Link
                href={getbookingUrl(room.locale, room.code)}
                target="_blank"
                className="border border-white py-1 px-9 md:py-2 lg:py-2 md:px-7 lg:px-7 font-subtitle text-xxs md:text-sm lg:text-sm text-white uppercase lg:text-center"
                id={gtmBookId}
              >
                {t("rooms:rooms_details.booking_now")}
              </Link>
              <Link
                href={{
                  pathname: `${t("routes:/rooms")}/[slug]`,
                  query: { slug: room.slug },
                }}
                className="font-subtitle text-xxs px-9 lg:px-0 md:text-sm lg:text-sm text-white uppercase underline lg:text-center"
                id={gtmMoreId}
              >
                {t("rooms:rooms_details.see_details")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoomsCard;
